import React from 'react';
import { TaskPriority } from '@demind-inc/core';

import { mdiFlag, mdiFlagOutline } from '@mdi/js';
import Icon from '@mdi/react';
import clsx from 'clsx';
import { getPriorityColor } from '../helpers';
import './PriorityFlag.scss';

interface PriorityFlagProps {
  priority?: TaskPriority;
  type?: 'outline' | 'fill';
  color?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const sizeMap = {
  small: 16,
  medium: 20,
  large: 24,
};

export const PriorityFlag: React.FC<PriorityFlagProps> = ({
  priority,
  type = 'fill',
  color,
  size = 'small',
  className,
}) => {
  const iconSize = sizeMap[size];
  const flagColor = color || getPriorityColor(priority);

  return (
    <Icon
      path={type === 'outline' ? mdiFlagOutline : mdiFlag}
      size={`${iconSize}px`}
      color={flagColor}
      className={clsx('priority-flag', `priority-flag--${size}`, className)}
    />
  );
};

export default PriorityFlag;
